import Card from 'v2/components/Card';
import CardActionLinkButton from 'v2/components/CardActionLinkButton';
import CardHeader from 'v2/components/CardHeader';
import InfoGrid from 'v2/components/InfoGrid';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DetailCard: FunctionComponent<Props> = ({
    className = '',
    editText,
    fields,
    onEdit,
    testId = TEST_ID,
    title
}) => (
    <Card className={className} testId={testId}>
        <CardHeader
            action={onEdit ? <CardActionLinkButton onClick={onEdit} text={editText} /> : undefined}
            title={title}
        />

        <InfoGrid className={styles.infoGrid} fields={fields} />
    </Card>
);

export default DetailCard;
